import _ from 'lodash';

import * as types from '../actions/types';

const initialState = {
  disciplineDetails: [],
  disciplines: [],
  disciplinesByTerm: [],
  isLoading: false,
  idCurr: 0,
  plansByCathedra: [],
  moreInfo: null,
  disciplinesByTerms: [],
  ccId: null
};

export default function discipline(state = initialState, action) {
  switch (action.type) {
    case types.DISCIPLINE_FETCH_COMPLETED: {
      const disciplineDetails = [];
      _.forOwn(_.groupBy(action.disciplineDetails, 'termname'), (value, key) => {
        const semesterId = _.find(value, sem => sem.termname === key)?.tlid;
        disciplineDetails.push({
          semester: key,
          semesterId,
          list: value,
          semesterFiles: action.commonFiles[action.educationYearId]?.[semesterId].semesterFiles,
          testFiles: action.commonFiles[action.educationYearId]?.[semesterId].testFiles,
          gradedTestFiles: action.commonFiles[action.educationYearId]?.[semesterId].gradedTestFiles,
          examFiles: action.commonFiles[action.educationYearId]?.[semesterId].examFiles,
        });
      },
      );

      disciplineDetails.sort((a, b) => a.semester - b.semester)
      return {
        ...state,
        idCurr: action.idCurriculum,
        disciplineDetails,
        ccId: action.ccId,
        isLoading: false,
      };
    }
    case types.DISCIPLINE_FETCH_STARTED:
      return {
        ...state,
        isLoading: true,
      };
    case types.ALL_DISCIPLINES_FETCH_STARTED:
      return {
        ...state,
        isLoading: true,
      };
    case types.ALL_DISCIPLINES_FETCH_COMPLETED:
      return {
        ...state,
        isLoading: false,
        disciplines: action.disciplines,
      };
    case types.FETCH_DISCIPLINES_BY_TERM_FETCH_START:
      return {
        ...state,
        isLoading: true,
      };
    case types.FETCH_CIRRICULUM_BY_CATHEDRA_START:
      return {
        ...state
      };
    case types.SET_DISCIPLINE_MORE_INFO:
      return {
        ...state,
        moreInfo: action.payload
      };
    case types.FETCH_CIRRICULUM_BY_CATHEDRA_COMPLETED:
      return {
        ...state,
        plansByCathedra: action.plansByCathedra,
      };
    case types.FETCH_DISCIPLINES_BY_TERM_FETCH_COMPLETED:
      return {
        ...state,
        // isLoading: true,
        disciplinesByTerm: action.disciplinesByTerm,
      };
    case types.FETCH_DISCIPLINES_BY_TERM_FETCH_COMPLETEDBYPARAMS:
    return {
        ...state,
        disciplinesByTerms: action.disciplinesByTerms,
      };

    default:
      return state;
  }
}
